import { useQuery } from "@tanstack/react-query";
import type { ApiBonificacao } from "pages/bonificacao/types/ApiBonificacao";
import type { ApiPrecoLeite } from "pages/referencia/precoLeite/types/ApiPrecoLeite";
import { apiRelReferencia } from "pages/relatorios/api/apiRelReferencia";
import { RelatorioContainer } from "pages/relatorios/components/RelatorioContainer";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioGetParams } from "pages/relatorios/types/ApiRelatorioParams";
import { buildRelatorioGetParams } from "pages/relatorios/utils/buildRelatorioGetParams";
import { useEffect, useMemo } from "react";
import { FilterBar } from "./FilterBar";
import { TableRelReferencia } from "./TableRelReferencia";

export type TApiRelatoriReferencia = {
	precoLeites: ApiPrecoLeite[];
	bonificacoes: ApiBonificacao[];
};

export function RelatorioReferencia() {
	const filter = useRelatorioStore((s) => s.filter);

	const limparFiltros = useRelatorioStore((s) => s.limparFiltros);

	const params: ApiRelatorioGetParams = useMemo(() => buildRelatorioGetParams(filter), [filter]);

	const { data, isFetching, refetch } = useQuery({
		queryKey: ["apiRelReferencia", params],
		queryFn: () => apiRelReferencia({ params }),
		enabled: false,
	});

	const registros = useMemo(
		() =>
			data || {
				precoLeites: [],
				bonificacoes: [],
			},
		[data],
	);

	useEffect(() => {
		limparFiltros();
	}, [limparFiltros]);

	const title = "Dados de Referência";

	return (
		<RelatorioContainer
			breadCrumbs={["Relatórios", "Referência"]}
			refetch={refetch}
			filterBar={<FilterBar />}
			loading={isFetching}
			title={title}
			registros={[registros]}
			table={<TableRelReferencia data={data} title={title} />}
		/>
	);
}
